// extracted by mini-css-extract-plugin
export default {"root":"Labs_root__lF8uK","header":"Labs_header__uwQd-","headerTitle":"Labs_headerTitle__h-L-9"};